const viVN = {
  // Claim Forms
  'claimForms.title': 'Biểu Mẫu Bồi Thường',
  'claimForms.photoTooSmall': 'Ảnh quá nhỏ, tối thiểu 10kb',
  'claimForms.photoTooLarge': 'Ảnh quá lớn, tối đa 5mb',
  'claimForms.videoTooLarge': 'Video quá lớn, tối đa 10mb',
  'claimForms.maxFilesExceeded': 'Không thể tải lên quá 50 tệp',
  'claimForms.fileAlreadyUploaded': 'Tệp này đã được tải lên',
  'claimForms.uploadError': 'Đã xảy ra lỗi, vui lòng tải lại và thử lại',
  'claimForms.checkFileType': 'Kiểm tra loại tệp của bạn',
  'claimForms.allowedFileTypes': 'Chỉ cho phép các loại tệp .jpg, .jpeg, .pdf, .png, .mp4, .mov và .avi',
  'claimForms.error': 'Lỗi',
  'claimForms.saved': 'Đã lưu',
  'claimForms.saveDraft': 'Lưu bản nháp',
  'claimForms.save': 'Lưu',
  'claimForms.select': 'Chọn ...',
  'claimForms.agreeWith': 'Tôi đồng ý với',
  'claimForms.termsAndConditions': 'Điều Khoản & Điều Kiện',
  'claimForms.fieldRequired': '{field} là bắt buộc',
  'claimForms.viewFile': 'Xem tệp',
  'claimForms.uploadFile': 'Tải file lên',
  'claimForms.changeFile': 'Thay đổi tệp',
  'claimForms.uploading': 'Đang tải lên...',
  'claimForms.reupload': 'Tải lên lại',
  'claimForms.agree': 'Đồng ý',
  'claimForms.tcStatement1': 'Tôi / Chúng tôi tuyên bố rằng tất cả thông tin được cung cấp ở trên là đúng sự thật theo hiểu biết và niềm tin của tôi / chúng tôi.',
  'claimForms.tcStatement2': 'Tôi / Chúng tôi đồng ý trao toàn quyền cho PT. Asuransi Simas Insurtech để kiểm tra và khảo sát nếu cần thiết.',
  'claimForms.tcStatement3': 'Tôi / Chúng tôi đồng ý rằng nếu tôi / chúng tôi đưa ra tuyên bố sai / gian lận liên quan đến khiếu nại hoặc che giấu bất kỳ điều gì về các sự kiện quan trọng dưới bất kỳ hình thức nào dẫn đến việc Chính sách bị hủy bỏ và mất tất cả các quyền khiếu nại hiện tại và tương lai.',
  // Create Claim
  'createClaim.title': 'Tạo Khiếu Nại',
  'createClaim.success': 'Thành công',
  'createClaim.error': 'Lỗi',
  'createClaim.uploadPhotoError': 'Lỗi tải lên ảnh',
  'createClaim.getBenefitsError': 'Lỗi lấy danh sách quyền lợi',
  'createClaim.validationFailed': 'Xác thực thất bại',
  'createClaim.loading': 'Đang tải...',
  'createClaim.noBenefitsFound': 'Không tìm thấy quyền lợi',
  'createClaim.next': 'Tiếp theo'
}

export default viVN
